<template>
  <div class="modal" style="padding-left:17px;">
    <div class="modal-dialog modal-dialog-centered modal-dialog-scrollable" :class="{'modal-lg': isLarge}" role="document">
      <div class="modal-content">
        <div class="modal-header" v-if="showHeader">
          <h6 class="modal-title">{{title}}</h6>
          <button class="close" @click="close" v-if="showClose">
            <span>&times;</span>
          </button>
        </div>
        <slot name="header"></slot>
        <div class="modal-body">
          <slot></slot>
        </div>
        <div class="modal-footer" v-if="showFooter">
          <slot name="footer">
            <button class="btn btn-secondary" @click="close" v-if="showClose">{{closeText || '关闭'}}</button>
            <button class="btn btn-primary" :class="[okCls]" @click="ok">{{okText || '确定'}}</button>
          </slot>
        </div>
      </div>
    </div>
  </div>
</template>
<script>
//events
//  show, close, callback
export default {
  props: {
    showHeader: {
      type: Boolean,
      default: true
    },
    showFooter: {
      type: Boolean,
      default: true
    },
    showClose: {
      type: Boolean,
      default: true
    },
    title: String,
    isLarge: {
      type: Boolean,
      default: false
    },
    closeText: String,
    okText: String,
    okCls: String
  },
  mounted() {
    this.show();
  },
  methods: {
    show() {
      $(this.$el).modal({
        backdrop: "static"
      });
      this._bindEvents();
    },
    ok() {
      this.$emit("callback", this);
    },
    close() {
      this.$emit("close");
      $(this.$el).modal("hide");
      $(this.$el).modal("dispose");
    },
    _bindEvents() {
      let vm = this;
      $(this.$el).on("show.bs.modal", function(event) {
        vm.$emit("show", vm);
        $(this).modal("handleUpdate");
      });
    }
  }
};
</script>